import React from 'react';
import PageLink from 'Components/PageLink'

import { SVGIconDanger } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from './CartSummary.scss'
import { numberFormatter, weightFormatter } from 'Utils/helpers/formatters';


type PropType = {
  deliveryFee?: number,
  paymentFee?: number,
  boxingFee?: number,
  productsTotal?: number,
  total: number,
  totalWeight?: number,
  weightLimit?: number
  hasWeightProblem?: boolean
  hideDeliveryFeeWarning?: boolean
  isShippingDiscounted?: boolean

  showRoundupPrice?: boolean
  roundUpValue?: number

  showDiscounts?: boolean

  cartTotalPrice: number,
  cartDiscountedPrice: number,
  couponCode?: string
}

const CartSummary: React.SFC<PropType> = (props) => {
  const { deliveryFee, productsTotal, total, totalWeight, weightLimit, hasWeightProblem, hideDeliveryFeeWarning, isShippingDiscounted, paymentFee, boxingFee } = props

  const discount = props.cartTotalPrice - props.cartDiscountedPrice

  const warningNoDeliveryFee = (
    <div className={cn(cg.gridX, cg.alignMiddle, cl.cartSummary__warningNoDeliveryFee)}>
      <div className={cn(cg.cell, cg.shrink, cl.iconWrapper)} aria-hidden={true}>
        <SVGIconDanger width={22} height={22} />
      </div>

      <div className={cn(cg.cell, cg.auto)}>
            A végösszeg a szállítás költségét, illetve MPL szállítás esetén a csomagolási költséget nem tartalmazza. <PageLink toPage="/szallitas" className={cg.linkWithIcon}>
            További információ
        </PageLink>
      </div>
    </div>
  )

  const useSmallPadding = !!productsTotal && (!!deliveryFee || isShippingDiscounted)

  return (
    <>
      <table className={cl.cartSummary}>
        <tbody>
          {!!productsTotal && (
            <tr>
              <td className={cn(cl.cartSummary__td)}>Termékek összesen:</td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__price)}>{numberFormatter(productsTotal)} Ft</td>
            </tr>
          )}

          {(!!deliveryFee || isShippingDiscounted) && (
            <tr>
              <td className={cn(cl.cartSummary__td, useSmallPadding && cl.smallPadding)}>Szállítási költség{isShippingDiscounted && ' (kedvezményes)'}:</td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__price, useSmallPadding && cl.smallPadding)}>{deliveryFee ? `${numberFormatter(deliveryFee)} Ft` : 'Ingyenes'}</td>
            </tr>
          )}
          
          {!!paymentFee && (
            <tr>
              <td className={cn(cl.cartSummary__td, useSmallPadding && cl.smallPadding)}>Utánvét:</td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__price, useSmallPadding && cl.smallPadding)}>{numberFormatter(paymentFee)} Ft</td>
            </tr>
          )}

        {!!boxingFee && (
            <tr>
              <td className={cn(cl.cartSummary__td, useSmallPadding && cl.smallPadding)}>Csomagolási díj:</td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__price, useSmallPadding && cl.smallPadding)}>{numberFormatter(boxingFee)} Ft</td>
            </tr>
          )}

          {/* TODO: discounts kijelzés */}  
          {props.showDiscounts === true && discount > 0 && (  
            <tr>
              <td className={cn(cl.cartSummary__td, useSmallPadding && cl.smallPadding)}>
                Kedvezmény: &nbsp;&nbsp;&nbsp;
                <strong>{`Kupon ${props.couponCode ? `(${props.couponCode})` : ''}`}</strong>
              </td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__price, useSmallPadding && cl.smallPadding)}> - {numberFormatter(discount)} Ft</td>
            </tr>
          )}

          {props.showRoundupPrice !== true && (
            <tr>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__tdHasBorderTop)}>
                <div className={cn(cg.gridX, cg.alignMiddle)}>
                  {!hideDeliveryFeeWarning && (
                    <div className={cn(cg.cell, cg.auto, cg.textLeft, cg.showForMedium)}>
                      {warningNoDeliveryFee}
                    </div>
                  )}

                  <div className={cn(cg.cell, cg.auto)}>Végösszeg:</div>

                </div>
              </td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__tdHasBorderTop, cl.cartSummary__totalPrice, cl.cartSummary__price)}>{numberFormatter(total)} Ft</td>
            </tr>
          )}

          {props.showRoundupPrice === true && props.roundUpValue && (
            <React.Fragment>
            <tr>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__tdHasBorderTop)}>
                <div className={cn(cg.gridX, cg.alignMiddle)}>
                  {!hideDeliveryFeeWarning && (
                    <div className={cn(cg.cell, cg.auto, cg.textLeft, cg.showForMedium)}>
                      {warningNoDeliveryFee}
                    </div>
                  )}

                  <div className={cn(cg.cell, cg.auto)}>Végösszeg adomány nélkül:</div>

                </div>
              </td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__tdHasBorderTop, cl.cartSummary__totalPrice, cl.cartSummary__price)}>{numberFormatter(total)} Ft</td>
            </tr>

            {/* TODO: if donation */}
            <tr>
              <td className={cn(cl.cartSummary__td, cl.smallPadding)}>
                <div className={cn(cg.gridX, cg.alignMiddle)}>
                  {!hideDeliveryFeeWarning && (
                    <div className={cn(cg.cell, cg.auto, cg.textLeft, cg.showForMedium)}>
                      {warningNoDeliveryFee}
                    </div>
                  )}

                  <div className={cn(cg.cell, cg.auto)}>Végösszeg:</div>
                </div>
              </td>
              <td className={cn(cl.cartSummary__td, cl.smallPadding, cl.cartSummary__totalPrice, cl.cartSummary__price, cl.red)}>{numberFormatter(props.roundUpValue! + total)} Ft</td>
            </tr>
            {/* if donation END */}
            </React.Fragment>
          )}

          {hasWeightProblem && !!totalWeight && (
            <tr>
              <td className={cn(cl.cartSummary__td)}>Összsúly (max.: {weightFormatter(weightLimit || 0)}):</td>
              <td className={cn(cl.cartSummary__td, cl.cartSummary__totalPrice, cl.cartSummary__price, cl.cartSummary__priceIsAlert)}>{weightFormatter(totalWeight)}</td>
            </tr>
          )}
        </tbody>
      </table>

      {!hideDeliveryFeeWarning && (
        <div className={cn(cg.hideForMedium, cl.hideForMedium)}>
          {warningNoDeliveryFee}
        </div>
      )}
    </>
  )
}

export default CartSummary
